<template>
    <div style="height: 100%">
        <div style="display: flex; width: 100%">
            <div style="width: 100%">
                <el-row class="filter-bar" ref="filterBar">
                    <el-select size="mini" v-model="formDatas.arfbType" clearable @change="partserch"
                        placeholder="请选择类型" style="width: 150px;">
                        <el-option label="扣减" :value="1"></el-option>
                        <el-option label="回退" :value="2"></el-option>
                    </el-select>
                    <el-input size="mini" v-model="formDatas.phone" clearable placeholder="请输入手机号"
                        style="width: 150px;" @keyup.enter.native="partserch"></el-input>
                    <el-input size="mini" v-model="formDatas.arfbRelationNum" clearable placeholder="请输入关联记录编码"
                        style="width: 180px;" @keyup.enter.native="partserch"></el-input>
                    <el-select size="mini" v-model="formDatas.arfbStatus" clearable @change="partserch"
                        placeholder="请选择状态" style="width: 130px;">
                        <el-option label="成功" :value="1"></el-option>
                        <el-option label="失败" :value="2"></el-option>
                    </el-select>
                    <div class="filter-actions">
          <el-button type="info" size="mini" icon="el-icon-search" @click="partserch"
                        style="">搜索</el-button>
          </div>
        </el-row>
            </div>
        </div>
        <div class="tablemain">
            <div class="tablecss" v-loading="tableLoading" element-loading-background="rgba(255, 255, 255, 0.9)" element-loading-text="数据加载中..." element-loading-spinner="el-icon-loading" custom-class="table-loading">
                <div style="width: 100%">
                    <ve-table ref="vetable" v-if="tableData" :columns="columns" :table-data="tableData"
                        :max-height="tableHight" :border-x="true" :border-y="true" :scrollWidth="10"
                        :cell-style-option="cellStyleOption" style="width: 100%" />
                    <div v-show="tableData.length == 0" class="empty-data">暂无数据</div>
                </div>
                <div class="table-pagination">
                    <ve-pagination :total="totalCount" :page-index="formDatas.currentPage"
                        :page-size="formDatas.pageSize" :page-size-option="[10, 20, 40, 80, 160, 320, 640, 1000, 2000]"
                        @on-page-number-change="pageNumberChange" @on-page-size-change="pageSizeChange" />
                </div>
            </div>
            <!-- 详情弹框 -->
            <el-dialog title="操作记录详情" :visible.sync="dialogDetail" width="60%" :before-close="handleDetailClose">
                <div class="detail-container">
                    <table class="detail-table">
                        <tr>
                            <td class="label">操作记录ID</td>
                            <td>{{ detailData.arfbId }}</td>
                            <td class="label">类型</td>
                            <td>
                                <el-tag :type="detailData.arfbType == 1 ? 'primary' : 'success'" size="small">
                                    {{ detailData.arfbType == 1 ? '扣减' : '回退' }}
                                </el-tag>
                            </td>
                        </tr>
                        <tr>
                            <td class="label">关联记录ID</td>
                            <td>{{ detailData.arfbRelationId }}</td>
                            <td class="label">关联记录编码</td>
                            <td>{{ detailData.arfbRelationNum }}</td>
                        </tr>
                        <tr>
                            <td class="label">手机号</td>
                            <td>{{ detailData.phone }}</td>
                            <td class="label">操作金额</td>
                            <td>{{ detailData.flowAmt }}</td>
                        </tr>
                        <tr>
                            <td class="label">状态</td>
                            <td colspan="3">
                                <el-tag :type="detailData.arfbStatus == 1 ? 'success' : 'danger'" size="small">
                                    {{ detailData.arfbStatus == 1 ? '成功' : '失败' }}
                                </el-tag>
                            </td>
                        </tr>
                        <tr>
                            <td class="label">创建时间</td>
                            <td>{{ detailData.createtime }}</td>
                            <td class="label">创建人</td>
                            <td>{{ detailData.createusername }}</td>
                        </tr>
                    </table>
                </div>
            </el-dialog>
        </div>
    </div>
</template>

<script>
import { calcTableHeight } from "../../utils/tableHeight.js";
import {
    getAjefRightsFundBillList, getAjefRightsFundBillDetails
} from "../../api/api";
export default {
    name: "",
    components: {},
    data() {
        return {
            dialogDetail: false,
            detailData: {},
            totalCount: 100,
            tableLoading: false,
            tableHight: 520,
            cellStyleOption: {
                headerCellClass: ({ column, rowIndex }) => {
                    if (rowIndex === 0) {
                        return "table-header-cell-class";
                    }
                },
            },
            columns: [
                {
                    field: "",
                    key: "a",
                    title: "序号",
                    width: 50,
                    fixed: 'left',
                    align: "center",
                    renderBodyCell: ({ row, column, rowIndex }, h) => {
                        return ++rowIndex;
                    },
                },
                {
                    field: "arfbType",
                    key: "arfbType",
                    title: "类型",
                    align: "center",
                    width: 80,
                    renderBodyCell: ({ row, column, rowIndex }, h) => {
                        return row.arfbType == 1 ? '扣减' : '回退';
                    },
                },
                {
                    field: "arfbRelationNum",
                    key: "arfbRelationNum",
                    title: "关联记录编码",
                    align: "center",
                    width: 180,
                },
                {
                    field: "phone",
                    key: "phone",
                    title: "手机号",
                    align: "center",
                    width: 120,
                },
                {
                    field: "flowAmt",
                    key: "flowAmt",
                    title: "操作金额",
                    align: "center",
                    width: 120,
                },
                {
                    field: "arfbStatus",
                    key: "arfbStatus",
                    title: "状态",
                    align: "center",
                    width: 80,
                    renderBodyCell: ({ row, column, rowIndex }, h) => {
                        return row.arfbStatus == 1 ? <el-tag type="success">成功</el-tag> : <el-tag type="danger">失败</el-tag>;
                    },
                },
                { field: "createtime", key: "createtime", title: "创建时间", width: 160, align: "center" },
                { field: "createusername", key: "createusername", title: "创建人", width: 100, align: "center" },
                {
                    field: "",
                    key: "d",
                    title: "操作",
                    width: 100,
                    align: "center",
                    fixed: "right",
                    renderBodyCell: ({ row, column, rowIndex }, h) => {
                        return (
                            <span>
                                <el-button
                                    size="mini"
                                    type="text"
                                    style="color: #409EFF"
                                    on-click={() => {
                                        this.showDetail(row);
                                    }}
                                >
                                    详情
                                </el-button>
                            </span>
                        );
                    },
                },
            ],
            tableData: [],
            formDatas: {
                currentPage: 1,
                pageSize: 10,
            },
        };
    },
    activated() {
        this.$nextTick(() => {
            this.tableHight = this.$store.state.windheight - 200 - this.$store.state.windheight * 0.04;
        });
    },
    watch: {
        "$store.state.windheight"(val) {
            this.$nextTick(() => {
                this.tableHight = calcTableHeight(this, val, 140);
            });
        },
    },
    deactivated() {},
    created() {
        this.tableHight = this.$store.state.windheight - 200 - this.$store.state.windheight * 0.04;
        this.getList();
    },
    mounted() {},
    methods: {
        handleDetailClose() {
            this.dialogDetail = false;
            this.detailData = {};
        },
        showDetail(row) {
            this.openLoading();
            getAjefRightsFundBillDetails({ arfbId: row.arfbId }).then((res) => {
                this.loadings.close();
                if (res.data) {
                    this.detailData = res.data;
                    this.dialogDetail = true;
                }
            }).catch(() => {
                this.loadings.close();
            });
        },
        openLoading() {
            this.loadings = this.$loading({
                lock: true,
                text: "加载中...",
                spinner: "el-icon-loading",
                background: "rgba(0, 0, 0, 0.7)"
            });
        },
        pageSizeChange(pageSize) {
            this.formDatas.pageSize = pageSize;
            this.partserch();
        },
        pageNumberChange(pageIndex) {
            this.formDatas.currentPage = pageIndex;
            this.tableLoading = true;
            getAjefRightsFundBillList(this.formDatas).then((res) => {
                this.tableLoading = false;
                this.tableData = res.data;
                this.totalCount = res.total;
            }).catch(() => {
                this.tableLoading = false;
            });
        },
        partserch() {
            this.formDatas.currentPage = 1;
            this.tableLoading = true;
            getAjefRightsFundBillList(this.formDatas).then((res) => {
                this.tableLoading = false;
                this.tableData = res.data;
                this.totalCount = res.total;
            }).catch(() => {
                this.tableLoading = false;
            });
        },
        getList() {
            this.tableLoading = true;
            getAjefRightsFundBillList(this.formDatas).then((res) => {
                this.tableLoading = false;
                this.tableData = res.data;
                this.totalCount = res.total;
            }).catch(() => {
                this.tableLoading = false;
            });
        },
    },
};
</script>

<style>
.table-header-cell-class {
    background: var(--bg-color) !important;
    color: var(--font-color) !important;
    border-right: 0px !important;
}

.easetable::-webkit-scrollbar {
    display: none;
}

.ve-table-container {
    height: auto !important;
}

.detail-container {
    padding: 10px;
}

.detail-table {
    width: 100%;
    border-collapse: collapse;
    font-size: 14px;
}

.detail-table tr {
    border-bottom: 1px solid #eee;
}

.detail-table tr:last-child {
    border-bottom: none;
}

.detail-table td {
    padding: 12px 10px;
    line-height: 1.5;
}

.detail-table td.label {
    background-color: #f5f7fa;
    color: #606266;
    font-weight: 500;
    width: 120px;
    text-align: right;
}
</style>
